import { Loader } from '@/components/ProtectedRoute';
import { getTelegramBindToken } from '@/service/weexpertService';
import { useTranslation } from 'react-i18next';
import { useQuery } from 'react-query';

export default function ClientBindTelegramPage() {
  const { t } = useTranslation();
  const telgram_bot_name = 'WeExpert_ChatBot'
  const { data, isLoading } = useQuery({ queryKey: 'clinet_telegram_token', queryFn: getTelegramBindToken });
  if (isLoading) {
    return <Loader />
  }
  return (
    <div className="flex flex-col items-center justify-center h-screen">
      <h1 className="text-2xl font-bold mb-4">{t('bind_telegram_title')}</h1>
      <p className="mb-4">{t('bind_telegram_description')}</p>
      <a
        href={`https://t.me/${telgram_bot_name}?start=${data.data.telegram_token}`}
        className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600 transition duration-200"
        target="_blank"
        rel="noopener noreferrer"
      >
        {t('bind_telegram_button')}
      </a>
      <p className="mt-4">{t('bind_telegram_instructions')}</p>
      <p className="mt-4">{t('bind_telegram_support')}</p>
      <p className="mt-4">{t('bind_telegram_thank_you')}</p>
    </div>
  );
}
